export function getLSTeamsInfo() {
    if (localStorage.getItem("teamsInfo")) {
      let lsItems = JSON.parse(localStorage.getItem("teamsInfo"));
      if (lsItems.length !== 0) {
        return lsItems;
      } else {
        return [];
      }
    }
  }